<template>
    <v-dialog persistent no-click-animation v-model="show" width="450">
        <div class="QCReassignEditor">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ $f.tc('assignee') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!--Content dialog-->
            <div class="px-10 py-10">
                <v-form ref="form" v-model="formValid" @submit="submit">
                    <div class="display-flex align-center">
                        <v-autocomplete
                            v-model="newAssignee"
                            :items="listUsers"
                            item-text="email"
                            item-value="email"
                            class="input-custom"
                        ></v-autocomplete>
                        <div class="btn-primary ml-10" @click="submit">{{ $f.tc('reassign') }}</div>
                    </div>
                </v-form>
                <div class="mt-6">
                    Current assignee: {{ currentAssignee }}
                </div>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DialogPromiseFormMixin from '@/modules/fptai/mixins/DialogPromiseFormMixin'
import FormRules from "@/modules/fptai/utils/FormRules";
import {AppServiceEventBus, AppServiceEventBusType} from "@/eventbus/appservice.eventbus";
import QcCampaignService from "@/services/qc.campaign.service";

const defaultRules = [FormRules.ruleRequired]

export default {
    name: 'QCReassignEditor',
    mixins: [DialogPromiseFormMixin],
    data() {
        return {
            newAssignee: '',
            options: [],
            assigneeList: [],
            currentAssignee: ''
        }
    },
    computed: {
        listUsers () {
            return this.options.filter(i => !this.assigneeList.includes(i.email))
        }
    },
    methods: {
        open(currentAssignee, options) {
            this.currentAssignee = currentAssignee ? currentAssignee : ''
            this.options = options ? options : []
            this.$refs.form.resetValidation()
            this.show = true
            return new Promise((resolve, reject) => {
                this.promise = {
                    resolve,
                    reject
                }
            })
        },
        submitValidForm() {
            this.close()
            this.promise.resolve(this.newAssignee)
        },
        cancel() {
            this.show = false
            this.promise.reject(false)
        },
    }
}
</script>

<style scoped lang="scss">
.QCReassignEditor {
    background: #FFFFFF;
    border-radius: 0 !important;
    overflow: hidden;

    .dialog-header {
        border-bottom: 1px solid #DADFEC;
    }

    .dialog-content {
        padding: 12px;
        max-height: 500px;
        overflow-y: auto;
    }

    .dialog-footer {
        justify-content: center;
        padding: 10px;
        border-top: 1px solid #DADFEC;
    }
}

table.table-assignees {
    border-collapse: collapse;
    width: 100%;
    font-size: 14px;

    tr {
        td {
            border: 1px solid #DADFEC;
            height: 40px !important;
            padding: 0 10px;
        }

        td:last-child {
            width: 67px;
            text-align: center;
        }
    }
}

.input-custom {
    position: relative;

    ::v-deep {
        .v-input__slot {
            height: 36px;
            background: #FFFFFF;
            border-radius: 0;
            border: 1px solid #DADFEC;
            outline: none;
            font-size: 14px;
            padding: 6px 10px 6px 10px;
            margin: 0;
            display: flex;
            align-items: center;

            &:before, &:after {
                border: none !important;
            }
        }
    }
}

::v-deep {
    .v-text-field {
        margin-top: 0 !important;
        padding-top: 0 !important;
    }

    .v-text-field__details {
        position: absolute;
        right: 36px !important;
        top: 11px !important;
    }

    .v-input input {
        height: 36px;
    }
}
</style>
